<template>
  <v-container>
    <carregando
      v-if="loading"
    />
    <v-card v-else>
      <v-toolbar
        dark
        color="primary"
      >
        <v-toolbar-title>Recurso da Habilitação</v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-form
          ref="form_recurso_habilitacao"
          v-model="valid"
          lazy-validation
        >
          <v-layout class="mt-1">
            <v-flex
              xs12
              sm6
            >
              <div class="ma-12 text-justify subheading grey--text">
                <span class="font-weight-bold">Nome do conselho:</span> {{ habilitacaoConselho.conselho.no_conselho }}
              </div>
            </v-flex>
          </v-layout>


          <v-layout class="mt-1">
            <v-flex
              md12
              subheading
              grey--text
              mt-2
              d-inline-flex
            >
              <div class="md6">
                <span class="font-weight-bold">CNPJ do órgão gestor do conselho:</span> {{ habilitacaoConselho.conselho.cnpj_formatado }}
              </div>

              <div class="md6">
                <span class="font-weight-bold">Nome do órgão gestor do conselho:</span> {{ habilitacaoConselho.conselho.no_orgao_gestor }}
              </div>
            </v-flex>
          </v-layout>

          <habilitacao-conselho-detalhes-visualizacao
            mostrar-indeferidos-apenas
          />
          <v-layout
            row
            wrap
          >
            <v-flex
              sm12
            >
              <v-flex
                title
                text--secondary
                my-3
              >
                Dados do Recurso
              </v-flex>
              <v-textarea
                v-model="recurso_habilitacao_conselho.ds_recurso"
                box
                label="* Parecer Recurso"
                name="input-7-4"
                rows="13"
                row-height="28"
                no-resize
                :rules="[rules.required, rules.tamanhoMaximoCaracteres]"
                :disabled="Object.keys(recursoHabilitacao).length > 0"
              />
            </v-flex>
            <v-flex
              v-for="arquivo in recurso_habilitacao_conselho.arquivos"
              :key="arquivo.tp_arquivo"
              sm6
            >
              <v-card class="mt-2 ml-3">
                <v-card-title
                  primary-title
                  style="height: 150px;"
                >
                  <h4>
                    <b>
                      {{ descricaoArquivos[arquivo.tp_arquivo] }}
                    </b>
                  </h4>
                </v-card-title>
                <v-card-text
                  class="recurso-habilitacao-conselho-file"
                >
                  <file
                    v-if="!Object.keys(recursoHabilitacao).length > 0"
                    v-model="arquivo.arquivo"
                    max-file-size="100MB"
                    max-files="1"
                    label-idle="Clique aqui para anexar um arquivo (PDF ou JPEG com limite de 100 MB)"
                    :accepted-file-types="acceptedFileTypes"
                    :readonly="isLocked"
                    :disabled="isLocked"
                    @input="fileAdded()"
                  />

                  <v-btn
                    v-else
                    color="blue-grey"
                    class="white--text text-capitalize"
                    outline
                    @click="downloadArquivo(arquivo.co_arquivo)"
                  >
                    Download anexo
                    <v-icon
                      right
                      dark
                    >
                      cloud_download
                    </v-icon>
                  </v-btn>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-form>
      </v-card-text>
      <v-layout
        v-if="!Object.keys(recursoHabilitacao).length > 0"
        wrap
        align-center
      >
        <v-flex offset-xs5>
          <v-btn to="/">
            Cancelar
          </v-btn>
          <v-btn
            :readonly="isLocked"
            :disabled="isLocked || !valid"
            color="primary"
            @click="abrirDialogo"
          >
            Enviar
          </v-btn>
        </v-flex>
      </v-layout>
    </v-card>

    <v-layout justify-center>
      <dialog-confirmacao
        v-model="dialog"
        title="Deseja realmente enviar?"
        text="Os dados enviados não poderão ser alterados posteriormente."
        cancel-text="Não"
        confirm-text="Sim"
        :is-loading="loading"
        @dialog-response="respostaDialog"
      />
    </v-layout>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import moment from 'moment';
import File from '@/core/components/upload/File';
import Carregando from '../../shared/components/CardCarregando';
import codigosFase from '../../fase/utils/codigosFase';
import DialogConfirmacao from '../../shared/components/DialogConfirmacao';
import HabilitacaoConselhoDetalhesVisualizacao from '../../conselho/views/HabilitacaoConselhoDetalhesVisualizacao';

export default {
  components: {
    File,
    Carregando,
    DialogConfirmacao,
    HabilitacaoConselhoDetalhesVisualizacao,
  },
  data: () => ({
    codigosFase,
    dialog: false,
    valid: false,
    isUsuarioPermitido: false,
    usuarioLogado: {},
    perfilUsuario: {},
    loading: true,
    recurso_habilitacao_conselho: {
      arquivos: [],
    },
    descricaoArquivos: {
      ato_normativo_conselho: 'Ato normativo que constituiu o conselho',
      documento_identificacao_responsavel: 'Documento de identificação do presidente do conselho de cultura (conforme item 2.8 do edital)',
      ata_reuniao_conselho: 'Ata da última reunião ordinária ou extraordinária do conselho',
      cpf_presidente_conselho: 'Documento de Cadastro de Pessoas Físicas (CPF) do presidente do conselho de cultura (conforme item 2.8 do edital)',
      ato_normativo_membro_conselho: 'Ato normativo que designa os atuais membros do conselho de cultura',
    },
    anexos: [],
    isLocked: false,
    fileLoaded: false,
    acceptedFileTypes: [
      'image/jpeg',
      'application/pdf',
    ],
    rules: {
      required: value => !!value || 'Campo não preenchido',
      tamanhoMaximoCaracteres: value => (!!value && value.length <= 3000) || 'Máximo 3000 caracteres',
    },
  }),
  watch: {
    habilitacaoConselho(habilitacao) {
      this.obterPorHabilitacaoConselho(habilitacao.co_habilitacao_conselho);
      this.recurso_habilitacao_conselho.arquivos = [];
      habilitacao.conselho.representante.arquivos.map((item) => {
        if (item.arquivo.situacaoArquivo.st_situacao === 'IRREGULAR') {
          this.recurso_habilitacao_conselho.arquivos.push({
            tp_arquivo: item.tp_arquivo,
            arquivo: {},
          });
        }
      });
      this.loading = false;
    },
    fases() {
      this.checkRecursoHabilitacao();
    },
    recursoHabilitacao(recurso) {
      this.recurso_habilitacao_conselho = {};
      this.recurso_habilitacao_conselho.arquivos = [];
      this.recurso_habilitacao_conselho = Object.assign({}, recurso);
    },
    usuarioLogado(user) {
      this.obterDadosHabilitacaoConselho(user.co_conselho);
    },
  },
  computed: {
    ...mapGetters({
      fases: 'fase/fases',
      usuario: 'conta/usuario',
      perfil: 'conta/perfil',
      conselho: 'conselho/conselhoUsuarioLogado',
      habilitacaoConselho: 'conselho/habilitacaoConselho',
      ativarRecursoHabilitacaoConselho: 'fase/ativarRecursoHabilitacaoConselho',
      recursoHabilitacao: 'recurso/recurso',
    }),
  },
  methods: {
    ...mapActions({
      definirMensagemSucesso: 'app/setMensagemSucesso',
      definirMensagemErro: 'app/setMensagemErro',
      obterDadosHabilitacaoConselho: 'conselho/obterDadosHabilitacaoConselho',
      enviarDadosRecursoHabilitacaoConselho: 'recurso/enviarDadosRecursoHabilitacaoConselho',
      obterPorHabilitacaoConselho: 'recurso/obterPorHabilitacaoConselho',
      downloadArquivo: 'shared/downloadArquivo',
    }),
    respostaDialog(tipoResposta) {
      if (tipoResposta) {
        this.salvar();
      } else {
        this.fecharDialogo();
      }
    },
    salvar() {
      this.recurso_habilitacao_conselho.co_habilitacao_conselho = this.habilitacaoConselho.co_habilitacao_conselho;
      this.validarAnexos();
      this.loading = true;

      this.enviarDadosRecursoHabilitacaoConselho(this.recurso_habilitacao_conselho)
        .then((response) => {
          this.definirMensagemSucesso(response.data.message);
          this.$router.push('/');
        }).finally(() => {
          this.loading = false;
          this.fecharDialogo();
        });
    },
    validarAnexos() {
      this.recurso_habilitacao_conselho.arquivos.forEach((item) => {
        if (Object.values(item).length === 0 || !item.arquivo.file) {
          return;
        }

        this.anexos.push({
          tp_arquivo: item.tp_arquivo,
          no_extensao: item.arquivo.fileExtension,
          no_mime_type: item.arquivo.fileType,
          no_arquivo: item.arquivo.filename,
          arquivoCodificado: item.arquivo.getFileEncodeBase64String(),
        });
      });
      this.recurso_habilitacao_conselho.arquivos = [];
      this.recurso_habilitacao_conselho.anexos = this.anexos;
    },
    abrirDialogo() {
      if (!this.$refs.form_recurso_habilitacao.validate()) {
        return false;
      }
      this.dialog = true;
      return true;
    },
    fecharDialogo() {
      this.dialog = false;
    },
    checkRecursoHabilitacao() {
      if (!this.isActiveRecursoHabilitacao()) {
        this.definirMensagemErro('Recurso da Habilitação indisponível!');
        this.$router.push('/').catch(() => {});
      }
    },
    checkUsuario() {
      if (!this.isUsuarioPermitido) {
        this.definirMensagemErro('Conselho de Cultura ou Organizações e Entidades Cultural não associada ao perfil');
        this.$router.push('/').catch(() => {});
      }
      return true;
    },
    isActiveRecursoHabilitacao() {
      let faseRecursoHabilitacao = this.fases.find(f => f.tp_fase == codigosFase.TP_RECURSO_HABILITACAO_CONSELHO);
      const dataInicio = moment(faseRecursoHabilitacao.dh_inicio).toDate().getTime();
      const dataAtual = moment().toDate().getTime();

      return dataAtual >= dataInicio;
    },
    fileAdded() {
      this.fileLoaded = !this.fileLoaded;
    },
  },
  mounted() {
    this.isUsuarioPermitido = (this.perfil.no_perfil == 'conselho');
    
    if (this.fases && this.fases.length > 0) {
      this.checkRecursoHabilitacao();
    }

    this.checkUsuario();

    this.usuarioLogado = this.usuario;
    this.perfilUsuario = this.perfil;
  },
};
</script>
